import { useState } from "react";
import CustomCalendar from "./CustomCalendar";
import { WrapperBox } from "../Theme/GlobalStyles";
import { Calender } from "../Theme/Icons";
import { globalTheme } from "../Theme/Theme";
import { Text } from "../Theme/Typography";

const DatePicker = ({ value, onChange, maxDate = null, maxDateMessage }) => {
  const [open, setOpen] = useState(false);

  const handleSelectDate = (date) => {
    onChange?.(date);
    setOpen(false);
  };

  return (
    <div style={{ position: "relative", width: "max-content" }}>
      <WrapperBox
        background={globalTheme.colors.grey8}
        padding={"10px"}
        borderRadius={50}
        borderColor={globalTheme.colors.grey6}
        className="pointer"
        onClick={() => setOpen((prev) => !prev)}
      >
          
    <Text font14 inter regular nuetral13>
      {new Date(value).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })}
    </Text>
  
      </WrapperBox>

      {open && (
        <CustomCalendar
          selectedDate={value}
          onSelectDate={handleSelectDate}
          onClose={() => setOpen(false)}
          maxDate={maxDate}
          {...(maxDateMessage ? { maxDateMessage } : {})}
        />
      )}
    </div>
  );
};

export default DatePicker;